import { render, staticRenderFns } from "./HuaxianContact.vue?vue&type=template&id=02169936&scoped=true&"
import script from "./HuaxianContact.vue?vue&type=script&lang=js&"
export * from "./HuaxianContact.vue?vue&type=script&lang=js&"
import style0 from "./HuaxianContact.vue?vue&type=style&index=0&id=02169936&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02169936",
  null
  
)

export default component.exports